// import $ from 'jquery';
// import funcUtil from "@/services/funcUtil.js";
// import _ from "lodash";

// export default {
// 	name: "toolbarUtility",
// 	props:{funcUtil},
//     created: () => {
//         // sprLib.baseUrl(urls.baseUrl);
// 	},
// 	data(){
// 		return {
// 			gridFilter : { logic: "or", filters: [] },
// 			gridName:""
// 		}
// 	},
//     methods: {
//         ToolBarClick(gridId , e){
//          this._baseToolBarEvents(gridId, e)
//         },
//         _baseToolBarEvents(gridId, e) {
// 					this.gridName=gridId;
// 					var kendoGridId = "#" + gridId;
// 					var grid = $(kendoGridId).data("kendoGrid");
// 					console.log(grid)

// 					switch (e.id) {
// 						case "btnRefresh":
// 							$("a#btnRefresh").removeClass('btnGlow')
// 							grid.dataSource.read();
// 							break;
// 						case "optExpandAll":
// 							$(".k-grouping-row").each(function () {
// 									grid.expandGroup(this);
// 							});
// 							break;
// 						case "optCollapseAll":
// 							$(".k-grouping-row").each(function () {
// 									grid.collapseGroup(this);
// 							});
// 							break;
// 						case "optExportSelected":
// 							// console.log("Grid Data Below")
// 							// grid.saveAsExcel();
// 							// var dataSource = $(kendoGridId).data("kendoGrid").dataSource;
// 							// var filters = dataSource.filter();
// 							// var allData = dataSource.data();
// 							// var query = new kendo.data.Query(allData);
// 							// var data = query.filter(filters).data;

// 							// var selectedItem = grid.dataItem(grid.select());
// 							// console.log(selectedItem);

// 							var selectedItem=[];
// 							grid.select().each(function(){
// 							//push the dataItem into the array
// 								selectedItem.push(grid.dataItem(this));
							
// 							});

// 							//return if no selected item

// 							if (selectedItem.length < 1) {
// 								//alert("Please Select Rows for Exporting")
// 								this._AlertPopup("Please Select Rows for Exporting","info")
								
// 							   return;
// 							}

// 							//console.log(selectedItem);
							
// 							var shownColumns = [];
// 							grid.columns.forEach(col => {
// 									//console.log(col)
// 									if (!col.hidden && col.title !== "Actions" && col.selectable !== true) {
// 											shownColumns.push(col);
// 									}
// 							});

// 							this.exportToExcel(shownColumns, selectedItem);
// 							//grid.saveAsExcel();
// 							break;

// 						case "optExportAll":
// 							console.log("Exporting All");

// 							// var data = grid.dataSource.data();

// 							// //only export hidden columns
// 							// var shownColumns = [];
// 							// grid.columns.forEach(col => {
// 							// 		if (!col.hidden && col.title !== "Actions" && col.selectable !== true) {
// 							// 				shownColumns.push(col);
// 							// 		}  
// 							// });

// 							//this.exportExcel(shownColumns, data);
// 							//alert(this.gridName)
// 							grid.saveAsExcel();
// 							//this.excelExport()
// 							break;

// 						case "optSaveSettings":
// 							e.preventDefault();
// 							localStorage[gridId] = kendo.stringify(grid.getOptions());
// 							console.log("Save Setting ID :" + gridId);
// 							this._AlertPopup("Your Grid Settings has been Saved","info")
// 							break;

// 						case "optResetSettings":
// 							console.log("Resetting Id for :" + gridId)
// 							localStorage.removeItem(gridId);
// 							grid.dataSource.filter({});
// 							grid.dataSource.group([]);
// 							grid.dataSource.sort({});
// 							this._AlertPopup("Your Grid Settings has been Reset","info")
// 							break;

// 						case "Standard":
// 							this.filterVestingData(grid,e);
// 						break;
// 						case "Supplemental":
// 							this.filterVestingData(grid,e);
// 						break;
// 					}
// 		},

// 		//Custome Export Excel for Selected Items
//         exportToExcel(shownColumns, data) {
// 			let self=this;

// 			if (data.length==0) {
// 				this._AlertPopup("There is no data for Exporting","info")
// 				return;
// 			}
//             //var gridColumns = shownColumns;
//             var columns = shownColumns.map(function (col) {
//                 return {
// 					value: col.title ? col.title : col.field,
//                     autoWidth: true,
//                     background: "#7a7a7a",
// 					color: "#fff"
//                 };
// 			});
			
// 			var rows = [{ cells: columns, type: "header" }];

//             for (var i = 0; i < data.length; i++) {
//                 var rowCells = [];
//                 for (var j = 0; j < shownColumns.length; j++) {
// 					var cellValue = data[i][shownColumns[j].field];
// 					if (shownColumns[j].type =='date') {
// 						rowCells.push({ value: cellValue , format: "MM/dd/yy"  });
// 					}else if(shownColumns[j].type == 'percent'){
// 						rowCells.push({ value: cellValue, format: "0.00%" });	
// 					}else if(shownColumns[j].type=='currency'){
// 						rowCells.push({value: cellValue, format: "$#,##0.00"})
// 					}
// 					else{
// 						rowCells.push({ value: cellValue });
// 					}
                   
//                 }
//                 rows.push({ cells: rowCells, type: "data" });
//             }
//             var workbook = new kendo.ooxml.Workbook({
//                 sheets: [
//                     {
//                         title: "Report",
//                         rows: rows
//                     }
//                 ]
// 			});
//             workbook.toDataURLAsync().then(function (dataURL) {
//                 kendo.saveAs({
//                     dataURI: dataURL,
//                     fileName: self.gridName + ".xlsx"
//                 });
//             });
// 		},
// 		//This method is called Automatically when grid grid.saveAsExcel() is fired.
// 		excelExport(e) {
// 			let self=this;
// 			//e.workbook.fileName = "Grid.xlsx";
// 			//alert("Hello")
// 			e.workbook.fileName = self.gridName + ".xlsx";
// 			//alert(e.workbook.fileName)
// 			var allColumnsArray = e.sender.columns;
// 			//console.log(e)

// 			let sheet = e.workbook.sheets[0];
// 			let rows =sheet.rows;


// 			//console.log(rows[0].cells)
// 			//Remove Custom Actions Column
// 			let actionIndex =_.findIndex(rows[0].cells, function(o) { return o.value == 'Actions'; });
// 			//console.log(actionIndex)
			
// 			if (actionIndex>=0) {
// 				//Remove Actions Column and Data
// 				_.forEach(rows, function(value, key) {
// 					value.cells.splice(actionIndex, 1);
// 				});
// 			}
// 			//Removing HTML from footer cells
// 			for (let ri = 0; ri < rows.length; ri++) {
// 				let row = rows[ri];
	  
// 				if (row.type == "group-footer" || row.type == "footer") {
// 				  for (let ci = 0; ci < row.cells.length; ci++) {
// 					let cell = row.cells[ci];
// 					if (cell.value) {
// 					  // Use jQuery.fn.text to remove the HTML and get only the text
// 					  cell.value = $(cell.value).text();
// 					  // Set the alignment
// 					  cell.hAlign = "right";
// 					  cell.format=(cell.value.includes("%"))?"0.00%":"#,##0.00"
// 					}
// 				  }
// 				}
// 			  }

// 			for (let i = 1; i < rows[0].cells.length; i++) {
// 				//Headers
// 				let Title= rows[0].cells[i].value;

// 				let columnType = _.find(allColumnsArray, function(o) { return o.title == Title; }).type;

// 				for (let j = 0; j < rows.length; j++) {
// 					if (rows[j].type == "data") {
// 						//Format Logic
// 						switch (columnType) {
// 							case "percent":
// 								rows[j].cells[i].format= "0.00%"
// 								break;

// 							case "date":
// 								rows[j].cells[i].format= "MM/dd/yy"
// 								break;

// 							case "currency":
// 								rows[j].cells[i].format= "$#,##0.00"
// 								break;

// 							default:
// 								break;
// 						}
// 					}
					
// 				}
// 			}	
// 		},
//         _loadGridSettings(gridId){
//             var kendoGridId = "#" + gridId;
//             var grid = $(kendoGridId).data("kendoGrid");
//             // localStorage["GridDefault"] = kendo.stringify(grid.getOptions());
    
// 			var options = localStorage[gridId];			
//             if (options) {
//                 grid.setOptions(JSON.parse(options));
// 			}
// 		},
// 		_filterDatabyDate (grid,fromDate, toDate,filterColumnName) {
// 			//Comparing with Date Boundary Conditions.
// 			fromDate=(fromDate) ? new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate()): null;
// 			toDate=(toDate) ? new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(), 23, 59, 59): null;

// 			if (fromDate != null && toDate != null) {
// 				//fromDate = new Date(fromDate).toISOString();
// 				//toDate = new Date(toDate).toISOString();
// 				let filter = { logic: "and", filters: [] };
// 				filter.filters.push({ field: filterColumnName, operator: "gte", value: fromDate });
// 				filter.filters.push({ field: filterColumnName, operator: "lte", value: toDate });
// 				grid.dataSource.filter(filter);
// 			}else if(toDate == null && fromDate != null){
// 				//fromDate = new Date(fromDate).toISOString();
// 				let filter = { logic: "and", filters: [] };
// 				filter.filters.push({ field: filterColumnName, operator: "gte", value: fromDate });
// 				grid.dataSource.filter(filter);
// 			}else if(fromDate == null && toDate != null){
// 				//toDate = new Date(toDate).toISOString();
// 				let filter = { logic: "and", filters: [] };
// 				filter.filters.push({ field: filterColumnName, operator: "lte", value: toDate });
// 				grid.dataSource.filter(filter);
// 			}
// 			else if(fromDate == null && toDate == null){
// 				let filter = {};
// 				grid.dataSource.filter(filter);
// 			}
// 		}
//     }
// }



import $ from 'jquery';
import funcUtil from "@/services/funcUtil.js";
import _ from "lodash";

export default {
	name: "toolbarUtility",
	props: { funcUtil },
	created: () => {
		// sprLib.baseUrl(urls.baseUrl);
	},
	data() {
		return {
			gridFilter: { logic: "or", filters: [] },
			gridName: "",
			excelFileName: "",
			headerList: []
		}
	},
	methods: {
		ToolBarClick(gridId, e) {
			this._baseToolBarEvents(gridId, e)
		},
		_baseToolBarEvents(gridId, args) {
			console.log(args);
			var e;
			if (args.fileName) {
				e = args[0];
				this.excelFileName = args.fileName;
				this.headerList = args.headers
			}
			else {
				e = args;
				this.excelFileName = gridId;
			}
			this.gridName = gridId;
			var kendoGridId = "#" + gridId;
			var grid = $(kendoGridId).data("kendoGrid");
			console.log(grid)

			switch (e.id) {
				case "btnRefresh":
					$("a#btnRefresh").removeClass('btnGlow')
					grid.dataSource.read();
					break;
				case "optExpandAll":
					$(".k-grouping-row").each(function () {
						grid.expandGroup(this);
					});
					break;
				case "optCollapseAll":
					$(".k-grouping-row").each(function () {
						grid.collapseGroup(this);
					});
					break;
				case "optExportSelected":
					// console.log("Grid Data Below")
					// grid.saveAsExcel();
					// var dataSource = $(kendoGridId).data("kendoGrid").dataSource;
					// var filters = dataSource.filter();
					// var allData = dataSource.data();
					// var query = new kendo.data.Query(allData);
					// var data = query.filter(filters).data;

					// var selectedItem = grid.dataItem(grid.select());
					// console.log(selectedItem);

					var selectedItem = [];
					grid.select().each(function () {
						//push the dataItem into the array
						selectedItem.push(grid.dataItem(this));

					});

					//return if no selected item

					if (selectedItem.length < 1) {
						//alert("Please Select Rows for Exporting")
						this._AlertPopup("Please Select Rows for Exporting", "info")

						return;
					}

					//console.log(selectedItem);

					var shownColumns = [];
					grid.columns.forEach(col => {
						//console.log(col)
						if (!col.hidden && col.title !== "Actions" && col.selectable !== true) {
							shownColumns.push(col);
						}
					});

					this.exportToExcel(shownColumns, selectedItem);
					//grid.saveAsExcel();
					break;

				case "optExportAll":
					console.log("Exporting All");
					if (args.headers) {
						var data = grid.dataSource.data();

						// //only export hidden columns
						var shownColumns = [];
						grid.columns.forEach(col => {
							if (!col.hidden && col.title !== "Actions" && col.selectable !== true) {
								shownColumns.push(col);
							}
						});

						this.exportToExcel(shownColumns, data);
					}
					else {
						//alert(this.gridName)
						grid.saveAsExcel();
					}
					//this.excelExport()
					break;

				case "optSaveSettings":
					e.preventDefault();
					localStorage[gridId] = kendo.stringify(grid.getOptions());
					console.log("Save Setting ID :" + gridId);
					this._AlertPopup("Your Grid Settings has been Saved", "info")
					break;

				case "optResetSettings":
					console.log("Resetting Id for :" + gridId)
					localStorage.removeItem(gridId);
					grid.dataSource.filter({});
					grid.dataSource.group([]);
					grid.dataSource.sort({});
					this._AlertPopup("Your Grid Settings has been Reset", "info")
					break;

				case "Standard":
					this.filterVestingData(grid, e);
					break;
				case "Supplemental":
					this.filterVestingData(grid, e);
					break;
			}
		},

		//Custome Export Excel for Selected Items
		exportToExcel(shownColumns, data) {
			let self = this;
			let autoWidthColumns = [];
			if (data.length == 0) {
				this._AlertPopup("There is no data for Exporting", "info")
				return;
			}
			//var gridColumns = shownColumns;
			var columns = shownColumns.map(function (col) {
				autoWidthColumns.push({ autoWidth: true });
				return {
					value: col.title ? col.title : col.field,
					background: "#7a7a7a",
					color: "#fff"
				};
			});
			//debugger;
			var rows = [];
			this.headerList.forEach(e => {
				var cellsValue = [];
				cellsValue.push({ value: e.id })
				cellsValue.push({ value: e.value, bold: true })
				rows.push({ cells: cellsValue, type: "data" });
			});
			rows.push({ cells: "", type: "data" });
			rows.push({ cells: columns, type: "header" });
			console.log("Data excel",data);
			for (var i = 0; i < data.length; i++) {
				var rowCells = [];
				for (var j = 0; j < shownColumns.length; j++) {
					var cellValue = data[i][shownColumns[j].field];
					if (shownColumns[j].type == 'date') {
						rowCells.push({ value: cellValue, format: "MM/dd/yyyy" });
					} else if (shownColumns[j].type == 'percent') {
						rowCells.push({ value: cellValue, format: "0.000%" });
					} else if (shownColumns[j].type == 'currency') {
						rowCells.push({ value: cellValue, format: "$#,##0.00" })
					}
					else if (shownColumns[j].type == 'vestpercent') {
						rowCells.push({ value: cellValue, format: "0.00%" });
					}
					else if (shownColumns[j].type == 'number') {
						rowCells.push({ value: cellValue, format: "0.00" })
					}
					else {
						rowCells.push({ value: cellValue });
					}

				}
				rows.push({ cells: rowCells, type: "data" });
			}
			// rows.push({cells:[{value:""}],type:"data"})
			// rows.push({cells:[{value:"Test"},{value:"Test"},{value:"Test"},{value:"Test"}],type:"data"})
			var workbook = new kendo.ooxml.Workbook({
				sheets: [
					{
						columns: autoWidthColumns,
						title: "Report",
						rows: rows
					}
				]
			});
			workbook.toDataURLAsync().then(function (dataURL) {
				kendo.saveAs({
					dataURI: dataURL,
					fileName: self.excelFileName
				});
			});
		},
		//This method is called Automatically when grid grid.saveAsExcel() is fired.
		excelExport(e) {
			let self = this;
			//e.workbook.fileName = "Grid.xlsx";
			//alert("Hello")
			//e.workbook.fileName = self.gridName + ".xlsx";
			//alert(e.workbook.fileName)
			var allColumnsArray = e.sender.columns;
			//console.log(e)

			let sheet = e.workbook.sheets[0];
			let rows = sheet.rows;


			//console.log(rows[0].cells)
			//Remove Custom Actions Column
			let actionIndex = _.findIndex(rows[0].cells, function (o) { return o.value == 'Actions'; });
			//console.log(actionIndex)

			if (actionIndex >= 0) {
				//Remove Actions Column and Data
				_.forEach(rows, function (value, key) {
					value.cells.splice(actionIndex, 1);
				});
			}
			//Removing HTML from footer cells
			for (let ri = 0; ri < rows.length; ri++) {
				let row = rows[ri];

				if (row.type == "group-footer" || row.type == "footer") {
					for (let ci = 0; ci < row.cells.length; ci++) {
						let cell = row.cells[ci];
						if (cell.value) {
							// Use jQuery.fn.text to remove the HTML and get only the text
							cell.value = $(cell.value).text();
							// Set the alignment
							cell.hAlign = "right";
							cell.format = (cell.value.includes("%")) ? "0.00%" : "#,##0.00"
						}
					}
				}
			}

			for (let i = 1; i < rows[0].cells.length; i++) {
				//Headers
				let Title = rows[0].cells[i].value;

				let columnType = _.find(allColumnsArray, function (o) { return o.title == Title; }).type;

				for (let j = 0; j < rows.length; j++) {
					if (rows[j].type == "data") {
						//Format Logic
						switch (columnType) {
							case "percent":
								rows[j].cells[i].format = "0.00%"
								break;

							case "date":
								rows[j].cells[i].format = "MM/dd/yy"
								break;

							case "currency":
								rows[j].cells[i].format = "$#,##0.00"
								break;

							default:
								break;
						}
					}

				}
			}
		},
		_loadGridSettings(gridId) {
			var kendoGridId = "#" + gridId;
			var grid = $(kendoGridId).data("kendoGrid");
			// localStorage["GridDefault"] = kendo.stringify(grid.getOptions());
			var options = localStorage[gridId];
			if (options) {
				grid.setOptions(JSON.parse(options));
			}
		},
		_filterDatabyDate(grid, fromDate, toDate, filterColumnName) {
			//Comparing with Date Boundary Conditions.
			fromDate = (fromDate) ? new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate()) : null;
			toDate = (toDate) ? new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(), 23, 59, 59) : null;

			if (fromDate != null && toDate != null) {
				//fromDate = new Date(fromDate).toISOString();
				//toDate = new Date(toDate).toISOString();
				let filter = { logic: "and", filters: [] };
				filter.filters.push({ field: filterColumnName, operator: "gte", value: fromDate });
				filter.filters.push({ field: filterColumnName, operator: "lte", value: toDate });
				grid.dataSource.filter(filter);
			} else if (toDate == null && fromDate != null) {
				//fromDate = new Date(fromDate).toISOString();
				let filter = { logic: "and", filters: [] };
				filter.filters.push({ field: filterColumnName, operator: "gte", value: fromDate });
				grid.dataSource.filter(filter);
			} else if (fromDate == null && toDate != null) {
				//toDate = new Date(toDate).toISOString();
				let filter = { logic: "and", filters: [] };
				filter.filters.push({ field: filterColumnName, operator: "lte", value: toDate });
				grid.dataSource.filter(filter);
			}
			else if (fromDate == null && toDate == null) {
				let filter = {};
				grid.dataSource.filter(filter);
			}
		}
	}
}